// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-02-28 14:20:55 +0100 (Fri, 28 Feb 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 150698 $
//  Purpose   : MODS related parts: http://www.loc.gov/standards/mods
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {loadLazy as ll} from 'uix/parts'
import log from 'uix/logging'

// ---Local imports

//~ export {Metadata, TableOfContents} from '../title'

// ---Chunked Parts
export const ModsForm = ll(() => import(/* webpackChunkName: 'modsforms' */ '../forms/part'))

export const EditModsElementOrder = ll(() =>
  import(/* webpackChunkName: 'config' */ './mods_elements')
)

export const ModsEditor = ll(() => import(/* webpackChunkName: 'mods' */ './editor'))
export const ModsRawCat = ll(() => import(/* webpackChunkName: 'mods' */ './raw_cat'))
export const ModsHist = ll(() => import(/* webpackChunkName: 'mods' */ './history'))

export const ModsGenerate = ll(() => import(/* webpackChunkName: 'mods' */ './generate'))

export const ModsRenderer = ll(() => import(/* webpackChunkName: 'mods' */ './rendered_table'))
